import request from '@/utils/request'

// 根据条件获取应用商品配置
export function getGamesConfig (filter) {
  return request.get('api/admin/app-games', filter)
}

// 获取所有应用商品配置
export function getGamesConfigAll () {
  return request.get('api/admin/app-games/all')
}

//添加应用商品配置
export function saveGameConfig (product) {
  return request.post('/api/admin/app-games', product)
}

// 修改应用商品配置
export function updateGameConfig (product) {
  return request.put('/api/admin/app-games/', product)
}

// 删除应用商品配置
export function deleteGameConfig (obj) {
  return request.post('/api/admin/app-games/delete', obj)
}

// 修改应用游戏状态
export function updateGamesStatus (data) {
  return request.put('/api/admin/updategames/', data)
}




// WEBPACK FOOTER //
// ./src/api/appGames.js